var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelecom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#F2F2FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6452_72990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 13.5H18.75C18.1533 13.5 17.581 13.7371 17.159 14.159C16.7371 14.581 16.5 15.1533 16.5 15.75V26.25C16.5 26.8467 16.7371 27.419 17.159 27.841C17.581 28.2629 18.1533 28.5 18.75 28.5H23.25C23.8467 28.5 24.419 28.2629 24.841 27.841C25.2629 27.419 25.5 26.8467 25.5 26.25V15.75C25.5 15.1533 25.2629 14.581 24.841 14.159C24.419 13.7371 23.8467 13.5 23.25 13.5ZM21 27C20.8146 27 20.6333 26.945 20.4792 26.842C20.325 26.739 20.2048 26.5926 20.1339 26.4213C20.0629 26.25 20.0443 26.0615 20.0805 25.8796C20.1167 25.6977 20.206 25.5307 20.3371 25.3996C20.4682 25.2685 20.6352 25.1792 20.8171 25.143C20.999 25.1068 21.1875 25.1254 21.3588 25.1964C21.5301 25.2673 21.6765 25.3875 21.7795 25.5417C21.8825 25.6958 21.9375 25.8771 21.9375 26.0625C21.9375 26.3111 21.8387 26.5496 21.6629 26.7254C21.4871 26.9012 21.2486 27 21 27Z",
    fill: "#1600A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6452_72990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelecom);
export default __webpack_public_path__ + "static/media/telecom.64739104d0622bde227c1146c4caf763.svg";
export { ForwardRef as ReactComponent };